import { z } from "zod";
import { createApiResponseSchema } from "../common/pagination";

export const FormalityFormSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  status: z.enum(["published"]),
  created_at: z.iso.datetime().nullable(),
  updated_at: z.iso.datetime().nullable(),
  deleted_at: z.iso.datetime().nullable(),
  form_assignments: z.array(
    z.object({
      id: z.string(),
      status: z.enum([
        "ASSIGNED",
        "IN_PROGRESS",
        "COMPLETED",
        "SUBMITTED",
        "CORRECTION",
        "FILL_CORRECTION",
        "FAILED_CORRECTION",
      ]),
      filled_form_id: z.string().nullable(),
      assigned_at: z.iso.datetime().nullable(),
      due_date: z.iso.datetime().nullable(),
      revisions: z.array(
        z.object({
          internal_deadline: z.string().nullable(),
          internal_started_at: z.iso.datetime().nullable(),
        }),
      ),
    }),
  ),
});

export type FormalityFormType = z.infer<typeof FormalityFormSchema>;

export const ApiFormalityFormResponseSchema =
  createApiResponseSchema(FormalityFormSchema);
export type ApiFormalityFormResponseType = z.infer<
  typeof ApiFormalityFormResponseSchema
>;
